export enum InputSize {
  EXTRA_SMALL = -1,
  SMALL = 0,
  MEDIUM = 1,
  LARGE = 2,
}
